<template>
  <div class="main-container">
    <div class="bread">
      <ExamIndexBread></ExamIndexBread>
      <span class="slash">/</span>
      <router-link :to="{ name: 'ExamPackage' }">套卷练习</router-link>
      <span class="slash">/</span>
      <span class="current">{{ detail.name }}</span>
    </div>
    <div class="main-content">
      <div class="detail-wrap">
        <div class="name-wrap">
          <div class="name">{{ detail.name }}</div>
          <img
            class="vip-logo"
            src="@/assets/images/vip/vip-free.png"
            alt=""
            v-if="detail.show.type == 7"
          />
          <span class="close" v-if="detail.show.type == 5">暂不开放</span>
          <div class="description">{{ detail.description }}</div>
        </div>
        <div
          style="margin: 16px 0"
          class="vip-price"
          v-if="
            detail.show.type == 3 ||
            detail.show.type == 1 ||
            detail.show.type == 6 ||
            detail.show.type == 2
          "
        >
          <span class="price_title" v-if="detail.show.type == 1">会员价:</span>
          <CurrencyNew
            :showFreeText="
              detail.show.type != 6 &&
              detail.show.type != 1 &&
              detail.show.type != 3
            "
            :price="detail.show.price || 0"
            :priceTwo="true"
            :isUnderlineLeft="false"
          ></CurrencyNew>
          <template v-if="detail.show.type == 1 || detail.show.type == 6">
            <span class="start">起</span>
            <img
              src="@/assets/images/vip/tool.png"
              alt=""
              @click="isShow = true"
            />
            <span class="divider">|</span>
            <span class="origin-price">
              原价:
              <CurrencyNew
                :showFreeText="false"
                :price="detail.show.original_price || 0"
                :priceTwo="true"
                :isUnderlineLeft="false"
              ></CurrencyNew>
            </span>
          </template>
        </div>
        <!--   免费套卷是否需要购买 0 不需要 1 需要     -->
        <div
          class="clockBtn"
          @click="deClock"
          v-if="
            detail.show.type == 3 ||
            detail.show.type == 1 ||
            detail.show.type == 6 ||
            detail.show.type == 2
          "
        >
          立即解锁
        </div>
        <img
          v-if="detail.show.type == 4"
          class="img"
          src="@/assets/images/vip/deblock.png"
          alt=""
        />
      </div>
      <div class="papers">
        <div class="paper" v-for="paper in detail.exam" :key="paper.id">
          <div>
            <div class="name">{{ paper.name }}</div>
            <div class="num">{{ paper.practiceNum }}人已练过</div>
          </div>
          <a
            class="labelBtn"
            v-if="
              detail.show.type == 3 ||
              detail.show.type == 6 ||
              detail.show.type == 1 ||
              detail.show.type == 2
            "
          >
            尚未解锁
          </a>
          <a
            class="link"
            @click="onDo(paper)"
            v-else-if="
              detail.show.type == 7 ||
              detail.show.type == 4 ||
              detail.show.type == 2
            "
          >
            <span>立即练习</span>
            <span>></span>
          </a>
          <a class="closeBtn" v-else-if="detail.show.type == 5">暂不开放</a>
          <a class="closeBtn" v-else-if="detail.show.type == 8">无权访问</a>
        </div>
      </div>
    </div>
    <VipPrice :isShow.sync="isShow" />
  </div>
</template>
<script>
import ExamIndexBread from "./components/ExamIndexBread.vue";
import VipPrice from "./components/VipPrice";

export default {
  name: "ExamPackagePaper",
  components: { ExamIndexBread, VipPrice },
  data() {
    return {
      isShow: false,
      id: this.$route.query.id,
      detail: { show: {} },
    };
  },
  async created() {
    // this.detail = await this.$http.get("/api/app/practice/package/" + this.id);
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.detail = await this.$http.get(
        "/api/app/practice/package/" + this.id,
      );
    },
    async onDo(paper) {
      let data = await this.$http.post("/api/app/practice/report", {
        type: 2,
        package_id: this.id,
        exam_id: paper.id,
      });
      if (data.length === 0) {
        this.$info("当前没有题目可以练习");
        return;
      }
      this.$router.push({
        name: "ExamPackagePaperDetail",
        query: {
          package_id: this.id,
          package_name: this.detail.name,
          id: paper.id,
          report_id: data,
        },
      });
    },
    //解锁套卷
    async deClock() {
      //如果是免费套卷但是需要下单的话
      if (this.detail.show.type == 2) {
        const shop_infos = [
          {
            shop_id: this.detail.id,
            shop_type: 21,
            product_number: 1,
            coupon_id: 0,
          },
        ];
        await this.$http.post("/api/app/order/downOrder", {
          order_type: 1,
          shop_infos: JSON.stringify(shop_infos),
          point:0
        });
        await this.getDetail();
        return;
      }
      this.$router.push({
        name: "OrderConfirm",
        params: { id: this.id },
        query: {
          type: 21,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  margin-bottom: 30px;
}
.detail-wrap {
  position: relative;
  background: rgba(255, 255, 255, 1);
  padding: 24px 24px 32px 24px;
  border-radius: 5px 5px 0 0;
  border-bottom: 3px dashed #cbcbcb;
  .img {
    position: absolute;
    width: 72px;
    height: 72px;
    right: 24px;
    top: 10px;
  }
  .close {
    display: inline-block;
    padding: 2px 12px;
    background: #e7e7e7;
    border-radius: 24px;
    line-height: 24px;
    text-align: center;
    color: #333;
    margin-left: 13px;
    position: relative;
    top: -2px;
  }

  .clockBtn {
    width: 110px;
    height: 36px;
    text-align: center;
    color: #fff;
    line-height: 36px;
    background: $primary-color;
    border-radius: 60px;

    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    cursor: pointer;
  }
  .price-wrap {
    display: inline-block;
    /deep/ .price {
      font-size: 16px;
      vertical-align: middle;
      position: relative;
      top: 2px;
    }
  }

  .name {
    margin-bottom: 12px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
    display: inline-block;
  }
  .vip-logo {
    width: 83px;
    height: 24px;
    margin-left: 13px;
    position: relative;
    top: 5px;
  }

  .description {
    line-height: 24px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
  }
  .vip-price {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #333333;
    .price_title {
      line-height: 22px;
      vertical-align: middle;
      margin-right: 8px;
    }
    .start {
      display: inline-block;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: $primary-color;
      line-height: 20px;
      vertical-align: middle;
      margin: 0 6px 0 2px;
    }
    img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      cursor: pointer;
    }
    .divider {
      font-size: 14px;
      position: relative;
      top: 0;
      padding: 0 11px 0 12px;
      color: #999;
    }
    .origin-price {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #999999;
      line-height: 22px;
      position: relative;
      top: 1px;
      /deep/ .price {
        color: #999;
        font-size: 14px;
        position: relative;
        top: 0;
      }
    }
  }
}
.papers {
  margin-top: 13px;
  border-radius: 0 0 5px 5px;
  padding: 0 24px;
  background: rgba(255, 255, 255, 1);
}
.paper {
  font-size: 14px;
  line-height: 1;
  padding: 24px 0;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;

  .name {
    margin-bottom: 12px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }

  .num {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }

  .btn {
    width: 86px;
    height: 32px;
    background: $primary-color;
    border-radius: 3px;
    line-height: 32px;
    text-align: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
    margin-top: 4px;
  }
  .labelBtn {
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: $primary-color;
    line-height: 22px;
  }
  .closeBtn {
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999;
    line-height: 22px;
  }
  .link {
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: $primary-color;
    line-height: 22px;
    cursor: pointer;
    & span {
      display: inline-block;
      margin-left: 5px;
    }
  }
  .link:hover {
    color: $primary-color-hover;
  }
  &:last-child {
    border: none;
  }
}
</style>
